import './App.scss';
import { cookie } from '@mvecom/common/utils/clientCookieManager';
import { stringToBoolean } from '@mvecom/common/utils/stringToBoolean';
import { useContext, useEffect, useState } from 'react';

import { Actions } from './actions/enums';
import { LoginModal } from './components/Modals/LoginModal/LoginModal';
import { MvAgentCart } from './components/MvAgentCart/MvAgentCart';
import { MvAgentFavourites } from './components/MvAgentFavourites/MvAgentFavourites';
import { useLogoutBusinessCustomer } from './hooks/useLogoutBusinessCustomer';
import { getCookieDomain } from './network/utils/getCookieDomain';
import { getRetailUnitAndLanguage } from './network/utils/getRetailUnitAndLanguage';
import { TranslationsContext, TranslationsState } from './providers/TranslationsProvider';
import { getEnv } from './utils/env';
import { getAuthEventCookieName } from './utils/getAuthCookieName';

const App = () => {
  const { translationsState, getTranslations } = useContext(TranslationsContext);
  const [loaded, setLoaded] = useState<Array<'cart' | 'favourites'>>([]);

  useLogoutBusinessCustomer();

  useEffect(() => {
    getTranslations();
  }, [getTranslations]);

  useEffect(() => {
    // Only used for CIAM
    if (loaded.includes('cart') && loaded.includes('favourites')) {
      const { retailUnit } = getRetailUnitAndLanguage();
      const environment = getEnv();
      const cookieDomain = environment === 'development' ? globalThis.location.hostname : getCookieDomain;
      const loggedInCookieName = getAuthEventCookieName('logged-in', retailUnit, environment);
      const loggedOutCookieName = getAuthEventCookieName('logged-out', retailUnit, environment);

      if (stringToBoolean(cookie.get(loggedInCookieName))) {
        cookie.del(loggedInCookieName, `/${retailUnit}`, cookieDomain);
        globalThis.ikea.pubsub.publish(Actions.USER_LOGGED_IN);
      }
      if (stringToBoolean(cookie.get(loggedOutCookieName))) {
        cookie.del(loggedOutCookieName, `/${retailUnit}`, cookieDomain);
        globalThis.ikea.pubsub.publish(Actions.USER_LOGGED_OUT);
      }
    }
  }, [loaded]);

  useEffect(() => {
    const agentLoaded = (agent: 'cart' | 'favourites') => () => {
      setLoaded((v) => [...v, agent]);
    };

    globalThis.ikea.pubsub.subscribe(Actions.CART_AGENT_LOADED, agentLoaded('cart'));
    globalThis.ikea.pubsub.subscribe(Actions.FAVOURITES_AGENT_LOADED, agentLoaded('favourites'));
  }, []);

  return (
    <>
      {translationsState === TranslationsState.DONE && (
        <>
          {import.meta.env.DEV && (
            <link rel="stylesheet" href="https://www.ikea.com/global/assets/fonts/en/fonts.css"></link>
          )}
          <MvAgentCart />
          <MvAgentFavourites />
          <LoginModal />
        </>
      )}
    </>
  );
};

export default App;
